import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoCampaniaNuevo from "../servicios/InfoCampaniaNuevo";
const Footer = lazy(() => import('../footer/Footer'));
function Campanias() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Para Hyundai la calidad y seguridad preventiva es prioridad. Consulta si tienes una campaña activa y agenda una cita en nuestros talleres sin costo alguno"
        />
        <meta name="keywords" content="garantía Hyundai" />
        <title>Campañas Hyundai</title>
      </Helmet>
      <Menu />
      <InfoCampaniaNuevo />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Campanias;